import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsVerificationStatus, PmsVerificationStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsVerificationStatus>
    useData={usePmsVerificationStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
